<template>
  <v-layout>
    <v-flex md8>

<!--       <v-flex md12>
        <h3>Select item to see checklist</h3>
      </v-flex>

      <v-flex md12>
        <v-radio-group v-model="itemType">
          <v-radio label="Inventory" :value="inventoryTypeID"></v-radio>
          <v-radio label="Service" :value="serviceTypeID"></v-radio>
        </v-radio-group>
      </v-flex> -->

      <!--<v-flex md12>-->
        <!--<v-select-->
          <!--:items="itemsList"-->
          <!--item-text="name"-->
          <!--item-value="id"-->
          <!--v-model="selectedItem"-->
          <!--label="Select item"-->
        <!--&gt;-->
          <!--<template slot="item" slot-scope="props">-->
            <!--{{ props.item.name }} - {{ props.item.description }}-->
          <!--</template>-->
          <!--<template slot="selection" slot-scope="props">-->
            <!--{{ props.item.name }} - {{ props.item.description }}-->
          <!--</template>-->
        <!--</v-select>-->
      <!--</v-flex>-->

      <ItemCheckList :item-id="$store.getters.currentUser.id" :item-type="itemType" :casesId="casesid"></ItemCheckList>
      <!--<ItemCheckList v-if="selectedItem > 0" :item-id="selectedItem" :item-type="itemType" :casesId="casesid"></ItemCheckList>-->

    </v-flex>
  </v-layout>
</template>

<script>
  import itemTypesMixins from '@/mixins/ItemTypes'
  import ItemCheckList from '@/components/ItemCheckList'
  import casesAPI from '@/api/resources/cases'
  import vendorsAPI from '@/api/resources/vendors'
  import consts from '@/config/consts'

  export default {
    name: 'CaseFormsCheckList',
    mixins: [ itemTypesMixins ],
    components: { ItemCheckList },
    watch: {
      servicesList (newVal) {
        this.itemsList = newVal
      },
      itemType (newVal) {
        switch (newVal) {
          case this.inventoryTypeID:
            this.itemsList = this.inventoriesList
            break
          case this.serviceTypeID:
            this.itemsList = this.servicesList
            break
        }
      }
    },
    data () {
      return {
        itemsList: [],
        inventoriesList: [],
        servicesList: [],
        selectedItem: 0,
        itemType: consts.schedules.SERVICE_TYPE_ID
        // itemType: 0
      }
    },
    created () {
      if (this.$store.getters.currentUserRoles.includes('vendor')) {
        vendorsAPI.getVendorItems(this.$store.getters.currentUser.id).then(result => {
          this.servicesList = result.services
          this.inventoriesList = result.inventories
        })
      } else {
        casesAPI.getLinkedInventories(this.casesid).then(result => {
          this.inventoriesList = result
        }, () => {})

        // TODO dublicate acl logic on backend
        casesAPI.getLinkedServices(this.casesid).then(result => {
          if (this.isPersonal) {
            result.forEach(item => {
              if (item.users_id === this.$store.getters.currentUser.id) {
                this.servicesList.push(item)
              }
            })
          } else {
            this.servicesList = result
          }
        }, () => {})
      }
    },
    props: {
      casesid: {
        type: Number,
        required: true
      },
      isPersonal: {
        type: Boolean,
        required: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CaseFormsCheckList.vue?5bcb509b